/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".results-listing__airports-toggle[_ngcontent-%COMP%]{margin:auto}"];
export { styles as styles };
